import { faCheckSquare, faClipboardCheck, faFileContract, faFileInvoice, faFilePrescription, faFileSignature } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { Check2Square, DashCircle, FileEarmarkCheck } from "react-bootstrap-icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ProgressBar from "../ProgressBar";

export default function ModalBihamtaGuarantee({ modalData, setModalData }) {

    const history = useHistory();
    const timeOutRef = useRef();
    const [enableClose, setEnableClose] = useState(false);
    const ulRef = useRef(null);
    const [isAtBottom, setIsAtBottom] = useState(false);

    const remainedDays = Number(modalData?.RemainedDays);
    const delayTime = Math.max(remainedDays, 60) * 1000;
    let endText = "گارانتی نرم افزار ";
    if (remainedDays === 0) {
        endText += "امروز ";
    }
    else {
        endText += "در تاریخ " + modalData.PExpDate;
    }
    if (remainedDays >= 0) {
        endText += " به پایان می‌رسد";
    }
    else {
        endText += " به پایان رسیده است.";
    }
    function handleCancel() {
        setModalData({ show: false });
        localStorage.removeItem("GUARANTEE_NOTIF");
        modalData.onClose?.();
    }
    function handleExtend() {
        modalData.onClose?.();
        history.push("/GuaranteeExtend");
    }
    const checkScroll = () => {
        const el = ulRef.current;
        if (!el) {
            setIsAtBottom(true);
            return;
        }

        setIsAtBottom(
            el.scrollHeight <= el.clientHeight ||
            el.scrollTop + el.clientHeight >= el.scrollHeight - 1
        );
    };
    useEffect(() => {
        checkScroll();
    }, [ulRef.current])
    useEffect(() => {
        if (timeOutRef.current) {
            clearTimeout(timeOutRef.current);
            timeOutRef.current = null;
        }

        setEnableClose(false);

        if (modalData?.delayedClose) {


            timeOutRef.current = setTimeout(() => {
                setEnableClose(true);
                timeOutRef.current = null;
            }, delayTime);
        } else {
            setEnableClose(true);
        }

        return () => {
            if (timeOutRef.current) {
                clearTimeout(timeOutRef.current);
                timeOutRef.current = null;
            }
        };
    }, [modalData?.show, modalData?.delayedClose, remainedDays]);

    if (!modalData?.show || remainedDays > 90) {
        return null;
    }

    return (

        <Modal show={modalData.show}>
            <Modal.Header className="headerStyle" style={{ position: "relative", marginBottom: "2px" }}>
                <span>
                    <FontAwesomeIcon icon={faFileContract} size="lg" />&nbsp;
                    گارانتی نرم افزار
                </span>
                {modalData?.delayedClose &&
                    <ProgressBar duration={delayTime} height={7} style={{ position: "absolute", bottom: -2, right: 0 }} color="#6b3090" />
                }
            </Modal.Header>

            <Modal.Body className="bodyStyle">
                <ul>
                    <li>
                        گارانتی نرم افزار{" "}
                        {remainedDays !== 0 && (
                            <>
                                در تاریخ <strong>{modalData.PExpDate}</strong>{" "}
                            </>
                        )}
                        {remainedDays === 0 && "امروز"}
                        {remainedDays >= 0 && "به پایان می‌رسد."}
                        {remainedDays < 0 && "به پایان رسیده است."}
                    </li>

                    {remainedDays > 0 && (
                        <li>
                            {remainedDays <= 30 && "تنها "}
                            <span
                                className="opacity-animation"
                                style={{ fontWeight: 900 }}
                            >
                                {remainedDays}
                            </span>
                            {" روز به پایان گارانتی باقی مانده است."}
                        </li>
                    )}

                    {remainedDays === 0 && (
                        <li>
                            گارانتی{" "}
                            <span
                                className="opacity-animation"
                                style={{ fontWeight: 900 }}
                            >
                                امروز
                            </span>{" "}
                            به پایان می‌رسد.
                        </li>
                    )}

                    {remainedDays < 0 && (
                        <li>
                            <span
                                className="opacity-animation"
                                style={{ fontWeight: 900 }}
                            >
                                {Math.abs(remainedDays)}
                            </span>{" "}
                            روز از پایان گارانتی گذشته است.
                        </li>
                    )}

                    {remainedDays > 0 && (
                        <li>
                            اکنون اقدام کنید تا از{" "}
                            <span
                                className="heart-animation"
                                style={{ color: "#a81111", fontWeight: 900 }}
                            >
                                {modalData.DiscountPercent}%
                            </span>{" "}
                            تخفیف بهره‌مند شوید.
                        </li>
                    )}

                </ul>
                {modalData.moreLines &&
                    <ul ref={ulRef} onScroll={checkScroll}
                        className="scThin"
                        style={{ listStyle: "none", paddingRight: 0, textJustify: "auto", maxHeight: "300px", overflow: "auto" }}>
                        {modalData.moreLines.map((line, i) =>
                            <li key={i} style={line.style}>
                                {line.text}
                            </li>)
                        }
                    </ul>
                }
                <div>
                    {/* <Button variant="info" className="group-Btn" onClick={handleExtend}><Check2Square size={18} /> تمدید گارانتی</Button> */}
                    {enableClose &&
                        <Button className="w-100"
                            style={{
                                boxShadow: "2px 2px 4px black !important",
                                fontSize: "13px",
                                padding: "8px"
                            }}
                            onClick={handleCancel} disabled={!isAtBottom}>
                            متوجه شدم
                        </Button>}
                </div>
            </Modal.Body>
        </Modal>
    )
}